"use strict";
var listElements = document.querySelector("ul");
function parseSalary(salary) {
    return parseInt(salary.replace("$", "").replace(",", ""));
}
function sortList(list) {
    var sortedList = Array.from(list.querySelectorAll("li")).sort(function(a, b) {
        var salaryA = parseSalary(a.dataset.salary);
        var salaryB = parseSalary(b.dataset.salary);
        return salaryB - salaryA;
    });
    sortedList.forEach(function(item) {
        return list.append(item);
    });
}
function getEmployees(list) {
    var items = list.querySelectorAll("li");
    return Array.from(items).map(function(item) {
        return {
            name: item.dataset.name,
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: Number(item.dataset.age)
        };
    });
}
sortList(listElements);
getEmployees(listElements);

//# sourceMappingURL=index.b967771e.js.map
